var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.me.profile == 'Master' || _vm.me.profile == 'Gerente')?_c('div',[_c('portal-component',{attrs:{"object":_vm.portals}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }